var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 66.052,
    height: 66.052,
    viewBox: "0 0 66.052 66.052",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "warning-clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4042",
    "data-name": "Path 4042",
    d: "M242.026-1233A32.889,32.889,0,0,0,209-1199.974a32.889,32.889,0,0,0,33.026,33.026,32.889,32.889,0,0,0,33.026-33.026A32.889,32.889,0,0,0,242.026-1233Zm-2.936,14.678h5.5v25.687h-5.5Zm2.936,40.365a3.467,3.467,0,0,1-3.67-3.67,3.467,3.467,0,0,1,3.67-3.669,3.467,3.467,0,0,1,3.67,3.669A3.467,3.467,0,0,1,242.026-1177.957Z",
    transform: "translate(-209 1233)",
    fill: "#2c53bb",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "warning-clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4041",
    "data-name": "Path 4041",
    d: "M192-1071.862H2657.936V-1248H192Z",
    transform: "translate(-192 1248)",
    fill: "#2c53bb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26355",
    "data-name": "Group 26355",
    transform: "translate(-379.859 -529.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Warning_Filled_20",
    "data-name": "Icon - Warning / Filled / 20",
    transform: "translate(379.859 529.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4016",
    "data-name": "Group 4016",
    clipPath: "url(#warning-clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4015",
    "data-name": "Group 4015",
    transform: "translate(-62.382 -55.043)",
    clipPath: "url(#warning-clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4040",
    "data-name": "Path 4040",
    d: "M204-1238H306.747v102.748H204Z",
    transform: "translate(-159.965 1274.696)",
    fill: "#2c53bb"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAlert);
export default __webpack_public_path__ + "static/media/warning-alert.fb2d0d75a0d475bbcc364c7b8d1b3818.svg";
export { ForwardRef as ReactComponent };